//get my subscriptions
export const GET_MY_SUBSCRIPTION_REQUEST = "GET_MY_SUBSCRIPTION_REQUEST";
export const GET_MY_SUBSCRIPTION_RECEIVE = "GET_MY_SUBSCRIPTION_RECEIVE";
export const GET_MY_SUBSCRIPTION_FAILURE = "GET_MY_SUBSCRIPTION_FAILURE";
export const RESET_GET_MY_SUBSCRIPTION = "RESET_GET_MY_SUBSCRIPTION";

//cancel subscription
export const CANCEL_SUBSCRIPTION_REQUEST = "CANCEL_SUBSCRIPTION_REQUEST";
export const CANCEL_SUBSCRIPTION_RECEIVE = "CANCEL_SUBSCRIPTION_RECEIVE";
export const CANCEL_SUBSCRIPTION_FAILURE = "CANCEL_SUBSCRIPTION_FAILURE";
export const RESET_CANCEL_SUBSCRIPTION = "RESET_CANCEL_SUBSCRIPTION";

//renew subscription
export const RENEW_SUBSCRIPTION_REQUEST = "RENEW_SUBSCRIPTION_REQUEST";
export const RENEW_SUBSCRIPTION_RECEIVE = "RENEW_SUBSCRIPTION_RECEIVE";
export const RENEW_SUBSCRIPTION_FAILURE = "RENEW_SUBSCRIPTION_FAILURE";
export const RESET_RENEW_SUBSCRIPTION = "RESET_RENEW_SUBSCRIPTION";